export const rsp = {
  refresh: 'rsp-data-refreshed',
  create: 'partner-created',
  list: 'rsp-list-received',
  short: 'rsp-short-list-received',
  get: 'rsp-details-received',
  put: 'rsp-details-updated',
  registration: 'registration-requests-received',
  credentials: 'partner-credentials-received',

  customers: 'rsp-customers-list-received',

  'confirm-registration-request': 'partner-created',

  'get-messages': 'messages-received',
  'send-message': 'message-transmitted',
  'delete-message': 'message-deleted',
  'update-message': 'message-updated',

  'get-unique-code-list': 'unique-code-list-received'
}
